<!-- @format -->

<template>
	<ul v-if="items && items.length > 0" class="pc-contextmenu__menu">
		<pc-menu-item
			v-for="(item, index) in items"
			:key="index"
			:icon="item.icon"
			:label="item.label"
			:info="item.info"
			:disabled="item.disabled"
			:divided="item.divided"
			:children="item.children"
			:color="item.color"
			:type="item.type"
			@click.once="handleClick(item, $event)"
			@submenu="handleActive"
		>
			<template #default="{ children, active }">
				<pc-menu v-if="children && active" :items="children" :class="menuClass" />
			</template>
		</pc-menu-item>
	</ul>
</template>

<script>
	import PcMenuItem from './menu-item';

	export default {
		name: 'PcMenu',
		components: {
			PcMenuItem,
		},
		inject: ['wrapper'],
		props: {
			items: {
				type: Array,
				default() {
					return [];
				},
			},
		},
		data() {
			this.rect = null;
			return {
				left: false,
				bottom: false,
			};
		},
		computed: {
			menuClass() {
				return {
					'is-left': this.left,
					'is-bottom': this.bottom,
				};
			},
		},
		mounted() {
			this.rect = this.$el ? this.$el.getBoundingClientRect && this.$el.getBoundingClientRect() : null;
		},
		methods: {
			handleClick(item, e) {
				/**
				 * 点击菜单项时触发
				 * @event click
				 * @param {Object} item 菜单项数据
				 * @param {Object} vm 菜单项实例
				 */
				this.wrapper.$emit('menu-click', item, e);
				this.wrapper.visible = false;
			},
			handleActive(vm) {
				const itemRect = vm.$el.getBoundingClientRect();
				const rect = this.rect;
				const targetRect = this.wrapper.triggerTarget.getBoundingClientRect();
				const x = itemRect.x + itemRect.width;
				const y = itemRect.y;
				this.bottom = rect.height + y - targetRect.top >= targetRect.height;
				this.left = rect.width + x - targetRect.left >= targetRect.width;
			},
		},
	};
</script>
